import { useQuery } from "@tanstack/react-query";

import { useAppState } from "../../../../context/StateContext";
import ApplicationsService from "../../../../services/applications.service";
import FleetService from "../../../../services/fleet.service";
import { FleetKeys } from "../../../../util/queries";

export const useActions = () => {
  const { currentUser } = useAppState();

  const getApplications = () =>
    useQuery(["get.all.applications"], () =>
      ApplicationsService.getAll({
        include: JSON.stringify([
          {
            association: "profiles",
            where: {
              initials: currentUser?.company?.profile?.initials,
            },
          },
        ]),
      })
    );

  const getAllFleet = (isUserDriverType: boolean) => {
    return useQuery({
      queryKey: FleetKeys.getAll([]),
      queryFn: async () => {
        const response = await FleetService.getAll({
          companyId: currentUser?.companyId,
          attributes: JSON.stringify(["id", "externalUuid", "fleetNumber", "model"]),
        });

        // TODO: For now, only let fleets with externalUuid to be assigned
        if (response?.data) return response.data.filter((fleet) => fleet.externalUuid);

        return [];
      },
      enabled: !!currentUser?.companyId && isUserDriverType,
    });
  };

  return {
    getApplications,
    getAllFleet,
  };
};
